module.exports = __webpack_public_path__ + "static/media/230.c4b7086e.svg";